"use client";

import { useEffect } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { recoverOrReport } from "@/components/error-boundary-utils";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Self-heal stale-chunk failures with a one-time reload; otherwise forward
  // to the app_errors log (rendered in /admin/errors as "react-boundary").
  useEffect(() => {
    recoverOrReport(error);
  }, [error]);

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center px-6 py-16 text-center">
      <h1 className="heading-page">Something went wrong</h1>
      <p className="mt-4 text-muted-foreground">
        We&apos;re sorry — an unexpected error occurred. Please try again.
      </p>
      <div className="mt-8 flex w-full max-w-sm flex-col gap-3 sm:w-auto sm:flex-row sm:justify-center">
        <Button onClick={reset} className="w-full sm:w-auto">
          Try again
        </Button>
        <Button
          variant="outline"
          onClick={() => window.location.reload()}
          className="w-full sm:w-auto"
        >
          Reload
        </Button>
        <Button variant="outline" asChild className="w-full sm:w-auto">
          <Link href="/">Go home</Link>
        </Button>
      </div>
    </div>
  );
}
